/* istanbul ignore file */
const moduleImport = async (url) => {
  try {
    return await import(/* webpackIgnore: true */ url)
  }
  catch (e) {
    console.error('failed to dynamic import url', url, e)
    throw e
  }
}

export default moduleImport
